export const name = "WNRS x Bumble BFF"
export const menu = "Bumble BFF"
export const crossover = "Bumble BFF"
export const suggestedPlayer = "2 players"
export const color = {
    primary: {
        main:  '#4098bc',
        contrastText: '#201e1f',
    },
    secondary: {
        main: '#201e1f',
    }
}
export const levels = ['Level 1 Perception', 'Level 2 Connection', 'Level 3 Reflection']
export const isExpansion = false

export const backDesc = [
    "Bumble BFF",
]

export const level1 = [
    "What about my\n Bumble profile made\n you swipe right?",
    "What do you think I was like\n in high school?",
]

export const level2 = [
    "What are you\n passionate about?",
    "How would you describe\n your ex in three words?\n How would they describe\n you?",
    "How's your heart\n today? Really?",
    "What type of social\n situation makes you feel\n the most awkward?",
    "What takes someone from\n a friend to a best friend?",
    "What have you let go of\n this year that's made the\n most positive change?",
    "What question are you\n trying to answer in your\n life right now?",
    "What's the nicest thing\n you can remember\n doing for a friend?\n Permission to brag.",
    "When was the last time\n someone made you feel\n special on your birthday?",
    "Has a quote ever changed\n your worldview?",

    "Wild Card Think of a movie that\n always makes you cry. On\n the count of three, say\n your answers out loud.\n (Both players)",
    "Wild Card Illustrate your\n current love life.\n 30 seconds. Compare.",
    "Wild Card Do you need advice on\n anything in your life\n right now?\n Permission to vent.\n (Both players)",
    "Wild Card Write down the three\n most important\n qualities in a BFF.\n One minute. Compare.\n (Both players.)",
]

export const level3 = [
    "What part of\n my personality wasn't\n showcased online?",
    "What do you admire\n most about me?",
]